<template>
    <div>
        <v-alert :value="requestFailed" type="error" outline class="mt-4">
            <span>{{requestErrorMessage}}</span>
        </v-alert>
        <v-card-title primary-title>
            <div>
                <div class="headline">Edit About Us</div>
            </div>
        </v-card-title>
        <v-card-text>
            <v-layout row>
                <v-flex xs12 md6>
                    <loading v-if="submitting" loadingMessage="Changing about us..."></loading>
                    <template v-else>
                        <about-us-form :initialValue="initialValue.profile.stats"
                                       cancelButtonText="Cancel"
                                       @update="formUpdated"
                                       @submitted="formSubmitted"
                                       @cancelled="formCancelled"
                                       submitButtonText="Save Changes"></about-us-form>
                    </template>
                </v-flex>
            </v-layout>
        </v-card-text>
        <cancel-form-warning @abort="resetWaring" @confirm="cancel" :warnDialog="warnDialog"></cancel-form-warning>
    </div>
</template>

<script>
  import AboutUsForm from '@/forms/company/AboutUsForm'
  import CancelFormWarning from '@/views/app/elements/CancelFormWarning'
  import {CrudFormMixin} from '@/views/app/company/crud/crud-mixins'

  export default {
    name: 'CompanyAboutUs',
    mixins: [CrudFormMixin],
    components: {
      AboutUsForm,
      CancelFormWarning
    },
    data: () => ({}),
    computed: {
      apiPath () {
        return `/admin/company/${this.existingData.uid}/stats`
      }
    }
  }
</script>

<style scoped>

</style>
